// Central backend URL resolution:
// 1. window.WAXUM_BACKEND_URL (set in public/config.js — editable on cPanel without rebuild)
// 2. REACT_APP_BACKEND_URL baked in at build time
export const BACKEND_URL =
  (typeof window !== "undefined" && window.WAXUM_BACKEND_URL) ||
  process.env.REACT_APP_BACKEND_URL;

export const API = `${BACKEND_URL}/api`;
